import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз ТЭ3 6965';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>Тепловоз Типа ТЭ3 №6965</h2>
                    <p>Построен в 1968 году на Луганском паровозостроительном заводе</p>
                    <p>Тип - грузовой, двухсекционный</p>
                    <p>Конструктивная скорость - 100 км/ч</p>
                    <p>Служебный вес - 2х126=252т</p>
                    <p>Мощность - 2х2000=4000 л.с.</p>
                    <p>Нагрузка на ось -21т</p>
                    <p>Управление тепловозом с одной кабины двумя секциям</p>
                    <p>Основной тепловоз эпохи реконструкции тяги. Именно он заменил паровозы на неэлектрифицированных дорогах. Простой и хорошо освоенный, он выпускался до тех пор, пока не устарел морально. Впрочем, в 80-х годах имелись даже предложения возобновить его производство. Серия ТЭ3 стала самой большой непрерывной серией среди всех локомотивов.</p>
                    <p>ТЭ3 - Дизель 2Д100, разработанный на основе американского судового дизеля, вышел весьма капризным и ненадёжным, потребовалось несколько лет, чтобы довести его до приемлемого уровня. Также на тепловозах первых выпусков были проблемы с генераторами и тяговыми электродвигателями. Тем не менее, в целом тепловоз для своего времени был достаточно хорош и оставил у железнодорожников приятную память. Первые локомотивы (не меньше 138) имели другую кабину по типу ТЭ2.</p>
                    <ul>
                        <li>прозвища: Ласточка, Тереза, Тройка</li>
                        <li>изготовители - Харьковский, Коломенский, Луганский заводы</li>
                        <li>главный конструктор - А.А.Кирнарский</li>
                        <li>годы выпуска 1953-1973</li>
                        <li>построено 6809 (без 1 секции)</li>
                        <li>списание: 1970-е - 1990-е</li>
                        <li>дизели: 2Д100 (2 x 2000 л.с.)</li>
                        <li>вес 252 т</li>
                        <li>нагрузка на ось 21 т</li>
                        <li>скорость 100 км/ч</li>
                        <li>мощность 3000 л.с.</li>
                    </ul>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt058.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt059.jpg')} /></div>
            </div>
        </>
    );
}